import { MdVerifiedUser } from "react-icons/md";

export default function CustomersHighlight() {
  const partnersList = [
    { name: "Onomo Hotel", country: "Tanzania", initials: "OH" },
    { name: "Roofing Solutions Company Limited", country: "Tanzania", initials: "RS" },
    { name: "M-GAS Resources Limited", country: "Tanzania", initials: "MR" },
    { name: "BHR Solutions Company Ltd", country: "Tanzania", initials: "BS" },
    { name: "Amlow Group Pty Ltd", country: "India", initials: "AG" },
  ];

  return (
    <div className="modern-customers bg-background">
      <div className="container">
        <div className="modern-customers-head text-center">
          <h6 className="modern-customers-eyebrow text-primary">Trusted Partners</h6>
          <h3 className="modern-customers-title">Organizations We Proudly Serve</h3>
          <p className="modern-customers-subtitle">
            Long-term collaborations built on quality delivery, operational discipline, and dependable support.
          </p>
        </div>

        <div className="modern-customers-track-wrap">
          <div className="modern-customers-track">
            {[...partnersList, ...partnersList].map((partner, i) => (
              <div key={i} className="modern-customer-card">
                <div
                  className="modern-customer-logo"
                  style={{
                    background: `linear-gradient(145deg, hsl(${(i * 43) % 360}, 70%, 45%), hsl(${(i * 43 + 65) % 360}, 72%, 58%))`,
                  }}
                >
                  {partner.initials}
                </div>
                <h6 className="modern-customer-name">{partner.name}</h6>
                <p className="modern-customer-country">
                  <MdVerifiedUser size={16} /> {partner.country}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>

      <style>{`
        .modern-customers {
          padding: 64px 0;
          overflow: hidden;
          font-family: "FontRegular", "Segoe UI", sans-serif;
        }

        .modern-customers-head {
          max-width: 760px;
          margin: 0 auto 28px;
        }

        .modern-customers-eyebrow {
          margin: 0 0 8px;
          font-size: 20px;
          text-transform: uppercase;
          color: #4d6f89;
          font-family: "FontSemiBold", "Segoe UI", sans-serif;
        }

        .modern-customers-title {
          margin: 0 0 10px;
          font-size: 30px;
          line-height: 1.2;
          color: #12324c;
          font-family: "FontSemiBold", "Segoe UI", sans-serif;
        }

        .modern-customers-subtitle {
          margin: 0;
          font-size: 16px;
          line-height: 1.75;
          color: #4a5c6d;
        }

        .modern-customers-track-wrap {
          overflow-x: hidden;
          mask-image: linear-gradient(to right, transparent 0%, #000 7%, #000 93%, transparent 100%);
        }

        .modern-customers-track {
          display: flex;
          gap: 14px;
          width: max-content;
          animation: customerMarquee 30s linear infinite;
          will-change: transform;
        }

        .modern-customer-card {
          width: 244px;
          min-height: 176px;
          background: #ffffff;
          border-radius: 18px;
          border: 1px solid #e5edf4;
          box-shadow: 0 12px 28px rgba(16, 43, 67, 0.08);
          padding: 16px;
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          transition: transform 0.22s ease, box-shadow 0.22s ease;
        }

        .modern-customer-card:hover {
          bakground:rgba(0,0,0,.35);
          box-shadow: 0 16px 32px rgba(16, 43, 67, 0.14);
        }

        .modern-customer-logo {
          width: 58px;
          height: 58px;
          border-radius: 14px;
          color: #ffffff;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          font-size: 18px;
          margin-bottom: 12px;
          font-family: "FontSemiBold", "Segoe UI", sans-serif;
        }

        .modern-customer-name {
          margin: 0 0 8px;
          font-size: 16px;
          line-height: 1.5;
          color: #1d3348;
          font-family: "FontSemiBold", "Segoe UI", sans-serif;
        }

        .modern-customer-country {
          margin: 0;
          display: inline-flex;
          align-items: center;
          gap: 6px;
          font-size: 14px;
          line-height: 1.5;
          color: #5b6f83;
        }

        @keyframes customerMarquee {
          from {
            transform: translateX(0);
          }
          to {
            transform: translateX(-50%);
          }
        }

        @media (max-width: 767px) {
          .modern-customers {
            padding: 52px 0;
          }

          .modern-customers-title {
            font-size: 24px;
          }

          .modern-customers-track {
            animation-duration: 34s;
          }

          .modern-customer-card {
            width: 212px;
          }
        }

        @media (prefers-reduced-motion: reduce) {
          .modern-customers-track {
            animation: none;
          }
        }
      `}</style>
    </div>
  );
}
